import { MenuItem, TextField } from '@mui/material';
import {
  SECTION_AUDIO,
  SECTION_IMAGE,
  SECTION_TEXT,
} from '../../common/CardEditorConstants';
import './CategorizingCardsEditor.scss';
import CardEditor from '../../common/card-editor/CardEditor';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  className: '',
  isSelected: false,
  selectedSection: SECTION_TEXT,
  selectedCardIndex: 0,
  onSectionSelected: () => null,
  instructions: {},
  cards: [],
  onNumberOfCardsChange: () => null,
  title: 'Number of Cards',
  options: [],
  createCardChildrenFuncton: () => null,
  isImageIncluded: true,
  isAudioIncluded: true,
  isVideoIncluded: true,
};

export default function CategorizingCardsEditor(props) {
  const {
    cards,
    isSelected,
    selectedCardIndex,
    selectedSection,
    onSectionSelected,
    onNumberOfCardsChange,
    title,
    options,
    createCardChildrenFuncton,
    className,
    isImageIncluded,
    isAudioIncluded,
    isVideoIncluded,
    ...rest
  } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div {...rest} className={`categorizing-cards-editor ${className}`}>
      <TextField
        select
        label={title}
        value={cards.length}
        variant='outlined'
        onChange={onNumberOfCardsChange}
        fullWidth
        className='categorizing-cards-selector'
        data-test='number-of-cards-selector'
      >
        {options.map((element, index) => (
          <MenuItem key={`grid-card-editor-selectable-value-${index}`} value={element.value}>
            {element.label}
          </MenuItem>
        ))}
      </TextField>
      <div className='cards-container'>
        {cards.map((card, index) => (
          <CardEditor
            key={`card-${index}`}
            config={{
              text: card.text,
              image: card.image,
              video: card.video,
              audio: card.audio,
            }}
            isSelected={isSelected && index === selectedCardIndex}
            selectedSection={selectedSection}
            onImageSelected={() => {
              onSectionSelected(SECTION_IMAGE, index);
            }}
            onTextSelected={() => {
              onSectionSelected(SECTION_TEXT, index);
            }}
            onAudioSelected={() => {
              onSectionSelected(SECTION_AUDIO, index);
            }}
            isVideoIncluded={isVideoIncluded}
            isImageIncluded={isImageIncluded}
            isAudioIncluded={isAudioIncluded}
          >
            {createCardChildrenFuncton && createCardChildrenFuncton(card, index)}
          </CardEditor>
        ))}
      </div>
    </div>
  );
}
